<template>
<div :class="bem()">
    <!-- 收藏提示需要 id -->
    <div id="user" :class="bem('wrapper')">
        <Popover
            v-show="user"
            :visible="session.isLogin ? undefined : false"
            :arrow="false"
            appendToBody
            placement="bottom-end"
            :popover-class="bem('popover')"
        >
            <div :class="bem('btn')" @click="handleClick">
                <Avatar :class="bem('avatar')" :src="avatar" size="small" :mark="mark" />
            </div>
            <div slot="content">
                <Info :class="bem('vip')" :session="session" />
                <div role="ul" :class="bem('menus')">
                    <a target="_black" :class="bem('menu')" href="https://www.gaoding.com/dam">
                        <Icon name="gdw-design-record-outline" />作图记录
                    </a>
                    <a target="_black" :class="bem('menu')" href="https://www.gaoding.com/me/settings">
                        <Icon name="gdw-user-outline" />账号设置
                    </a>
                    <!-- <span :class="bem('menu')">
                        <Icon name="settings_outline" />偏好设置
                    </span>-->
                    <a target="_black" :class="bem('menu')" href="https://www.gaoding.com/me/orders">
                        <Icon name="gdw-personal-library-outline" />订单/发票
                    </a>
                    <a target="_black" :class="bem('menu')" href="https://www.gaoding.com/me/certs">
                        <Icon name="gdw-empower-outline" />授权记录
                    </a>
                    <span :class="bem('menu')" @click="logout"> <Icon name="gdw-exit-outline" />退出账号 </span>
                </div>
            </div>
        </Popover>
        <div v-show="!user" :class="bem('login')" @click="login">
            <span :class="bem('text')">登录/注册</span>
        </div>
    </div>
</div>

</template>
<script>
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Popover, Icon, Avatar } from '@gaoding/gdui';
import { bemMixin } from '@gaoding/gdui/lib/utils';
import Info from './info';
export default {
  name: 'gm-v3-header-user',
  components: {
    Popover,
    Icon,
    Avatar,
    Info
  },
  mixins: [bemMixin],
  props: {
    session: {
      type: Object,
      default: function _default() {
        return {};
      },
      require: true
    }
  },
  computed: {
    user() {
      var session = this.session;
      return session.isLogin ? session.user : session.cachedUser;
    },

    avatar() {
      return this.user ? this.user.avatar : '';
    },

    mark() {
      if (!this.user || !this.user.vip) return undefined;
      var level = this.user.vip.level;
      var vipId = this.user.vip.vipId;
      var isExpired = this.user.vip.isExpired;

      if (vipId === 1 && !isExpired) {
        return 'old-vip';
      }

      if (vipId === 2 && !isExpired) {
        return 'old-svip';
      }

      if ((level === 100 || level === 1) && !isExpired) {
        return 'vip';
      }

      if ((level === 200 || level === 2) && !isExpired) {
        return 'svip';
      }

      if (level === 80 && !isExpired) {
        return 'pvip';
      }

      return undefined;
    }

  },
  methods: {
    login() {
      this.session.login();
    },

    logout() {
      this.session.logout();
    },

    handleClick() {
      window.open('https://www.gaoding.com/me/settings');
    }

  }
};
</script>
<style>
.gm-v3-header-user-info a {
  text-decoration: none !important;
}
.gm-v3-header-user .g-popover__container {
  display: block;
}
.gm-v3-header-user__popover.g-popover {
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.1) !important;
  margin-top: 8px;
  overflow: hidden;
}
.gm-v3-header-user__btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.gm-v3-header-user__login {
  cursor: pointer;
}
.gm-v3-header-user__text {
  font-size: 14px;
  line-height: 24px;
  color: #7f8792;
  vertical-align: middle;
}
.gm-v3-header-user__text:hover {
  color: #000;
}
.gm-v3-header-user__text > em {
  color: #d8d8d8;
  margin: 0 4px;
}
.gm-v3-header-user__name {
  margin: 0 8px;
  font-size: 12px;
  color: #000;
  line-height: 18px;
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gm-v3-header-user__icon {
  color: #7f8792;
}
.gm-v3-header-user__menus {
  padding: 8px 0;
}
.gm-v3-header-user__menu {
  display: block;
  padding: 10px 16px;
  line-height: 20px;
  color: #000;
  cursor: pointer;
}
.gm-v3-header-user__menu > svg {
  font-size: 20px;
  vertical-align: bottom;
  margin-right: 12px;
  color: #444950;
}
.gm-v3-header-user__menu:hover {
  color: #000;
  background: #eee;
}

</style>
